import { CssStates, embeddedImagesBase64, IGrapesJSProjectData } from "../../../interfaces/VisageUI";

const GjsTemplateBranch: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"flex-direction":"column",
				"height":"100%",
				"display":"flex",
				"justify-content":"center",
				"align-items":"center",
				"align-content":"center",
				"padding-top":"0vw",
				"padding-bottom":"0vw"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"#Ca1c9e971-4cdc-4962-9ad3-0a13cbb4ec96"
			],
			"style":{
				"flex-direction":"row",
				"justify-content":"flex-start",
				"align-items":"flex-start",
				"text-align":"center",
				"flex-wrap":"wrap",
				"align-content":"flex-start",
				"max-width":"63vw",
				"display":"flex",
				"padding-top":"0vw",
				"padding-right":"0vw",
				"padding-bottom":"0vw",
				"padding-left":"0vw",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"0vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#C79b5bd50-2619-49f1-bb58-65468ca5eaea"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"width":"100%",
				"height":"6vw",
				"position":"absolute",
				"display":"flex",
				"background":"rgba(30, 30, 30, 0.9)",
				"flex-direction":"row",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#C37881c0c-9e1a-484e-a367-0962e4fe0679"
			],
			"style":{
				"width":"auto",
				"height":"70%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#Ce817947a-fae3-4aab-be2a-410feadd3c2a"
			],
			"style":{
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"display":"flex",
				"padding-bottom":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Ca7d17367-12f2-42a2-9c14-eb2e5220f85d"
			],
			"style":{
				"width":"70%",
				"height":"70%"
			}
		},
		{
			"selectors":[
				"#C438075de-6fb9-4fd5-96e8-9aeb9c51d8f9"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2.5vw",
				"font-weight":"700",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		},
		{
			"selectors":[
				"#Cc5fc91b1-ad00-42dd-afeb-34e275a95747"
			],
			"style":{
				"position":"absolute",
				"right":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"none",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center",
				"width":"8.999583333333332vw",
				"height":"17.24898148148148vw"
			}
		},
		{
			"selectors":[
				"#Ccf56aadf-2a5e-4ea4-ae17-9272ff51fead"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"4.5vw",
				"border-top-right-radius":"4.5vw",
				"border-bottom-right-radius":"4.5vw",
				"border-bottom-left-radius":"4.5vw",
				"width":"9vw",
				"height":"9vw",
				"padding-left":"0.5vw",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"padding-top":"1.5vw",
				"padding-bottom":"1.5vw",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Ce23ef9cd-6ddc-45ca-82de-d1f7d3917098"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C936ed833-5055-427b-b5d0-1cbb8c31c3e4"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"width":"7.25vw",
				"height":"7.25vw",
				"padding-right":"0.5vw",
				"padding-top":"1.25vw",
				"padding-bottom":"1.25vw",
				"left":"calc(50% + 0vw)",
				"bottom":"0vw",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cc7e5fad7-c046-4135-ae88-df9f9049cf31"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C6b4fbd22-bae7-4af1-b96d-1b4fa07bad02"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cdb4e349c-aa95-4b12-919e-19717cb97706"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Cf3822b7f-9552-46a5-be53-c3446d92620e"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C9c2cb355-0344-4070-a801-4b0eb87d88cc"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C09c8ecc4-1d42-442f-9280-b0c75dd769bc"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C12010ac9-624c-40f5-9f63-bbe250c41691"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C1aae36a9-4a19-4bc7-81d9-6e8a6f561747"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C4346ec72-4269-4f6b-88ed-1d1ebf21a966"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Ccc9c0f20-5933-42e1-8abd-b110cbdaa5ee"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C3347f32f-bf7c-44e4-89ff-acd4aa030db7"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cf5330c67-469b-4c44-9e9f-fc3d61bb1704"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Cf173da85-b0bf-4b1d-9c9e-d76539c02c17"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Ce2a3f0ae-7be9-4a6e-87e3-1ab3bf5a3b17"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C5f0508ef-fce6-47fa-9443-dfc7009be08a"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cb87c017d-b6ad-406d-81bd-cb3fd541b4e0"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Ca8bc6a70-2f0b-4e99-85ee-09a16bdda317"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C8d45c509-2e3d-4def-9c06-674d44626703"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Cecc7aa29-015f-48c0-ab4b-02a85e316455"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cf88987f7-7406-4de3-85bf-8e0eb2fb0621"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C3eca7557-32fa-4f27-9fb3-559418042c13"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cb56cf33e-c160-4689-9106-04230c77b664"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C7695bff2-850b-469f-8efa-55e416676584"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cce1a39e9-df54-4ba2-8336-3e5508b5301f"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C3f0bfbff-1ed4-4d14-b835-3cbeea59b04c"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C35a4b64e-1d32-4338-b304-1cf302735980"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C6479da3f-cd86-4746-8863-5891e17e41d1"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#Cafe3c6df-9de9-4f12-8521-1de86f9509bc"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#Ca65dea04-5f94-4e1f-9036-b1c0607acf60"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C780ac222-a83d-4048-8c24-aa16e9d38a90"
			],
			"style":{
				"font-size":"2vw",
				"font-weight":"700",
				"color":"rgba(48, 48, 48, 1)"
			}
		},
		{
			"selectors":[
				"#C75ada4ee-49b2-42d4-ab8e-78c610246fe6"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px",
				"background":"linear-gradient(0deg, RGB(197, 197, 197) 0%, rgba(241,241,241,1) 100%)",
				"margin-top":"0.5vw",
				"margin-bottom":"0.5vw",
				"margin-left":"0.5vw",
				"margin-right":"0.5vw"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"name":"Container",
										"attributes":{
											"id":"C79b5bd50-2619-49f1-bb58-65468ca5eaea",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Image",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C37881c0c-9e1a-484e-a367-0962e4fe0679",
													"asset-id":"",
													"src":embeddedImagesBase64.scopeCube,
												}
											},
											{
												"type":"e-text",
												"name":"Text",
												"content":"Title",
												"attributes":{
													"id":"C438075de-6fb9-4fd5-96e8-9aeb9c51d8f9",
												}
											}
										],
										"custom-name":"Banner",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"attributes":{
											"id":"Ca1c9e971-4cdc-4962-9ad3-0a13cbb4ec96",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C6b4fbd22-bae7-4af1-b96d-1b4fa07bad02",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 1",
														"attributes":{
															"id":"Cdb4e349c-aa95-4b12-919e-19717cb97706",
														}
													}
												],
												"custom-name":"Button 1"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C9c2cb355-0344-4070-a801-4b0eb87d88cc",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 2",
														"attributes":{
															"id":"Cf3822b7f-9552-46a5-be53-c3446d92620e",
														}
													}
												],
												"custom-name":"Button 2"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C12010ac9-624c-40f5-9f63-bbe250c41691",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 3",
														"attributes":{
															"id":"C09c8ecc4-1d42-442f-9280-b0c75dd769bc",
														}
													}
												],
												"custom-name":"Button 3"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C4346ec72-4269-4f6b-88ed-1d1ebf21a966",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 4",
														"attributes":{
															"id":"C1aae36a9-4a19-4bc7-81d9-6e8a6f561747",
														}
													}
												],
												"custom-name":"Button 4"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C3347f32f-bf7c-44e4-89ff-acd4aa030db7",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 5",
														"attributes":{
															"id":"Ccc9c0f20-5933-42e1-8abd-b110cbdaa5ee",
														}
													}
												],
												"custom-name":"Button 5"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"Cf173da85-b0bf-4b1d-9c9e-d76539c02c17",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 6",
														"attributes":{
															"id":"Cf5330c67-469b-4c44-9e9f-fc3d61bb1704",
														}
													}
												],
												"custom-name":"Button 6"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C5f0508ef-fce6-47fa-9443-dfc7009be08a",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 7",
														"attributes":{
															"id":"Ce2a3f0ae-7be9-4a6e-87e3-1ab3bf5a3b17",
														}
													}
												],
												"custom-name":"Button 7"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"Ca8bc6a70-2f0b-4e99-85ee-09a16bdda317",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 8",
														"attributes":{
															"id":"Cb87c017d-b6ad-406d-81bd-cb3fd541b4e0",
														}
													}
												],
												"custom-name":"Button 8"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"Cecc7aa29-015f-48c0-ab4b-02a85e316455",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 9",
														"attributes":{
															"id":"C8d45c509-2e3d-4def-9c06-674d44626703",
														}
													}
												],
												"custom-name":"Button 9"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C3eca7557-32fa-4f27-9fb3-559418042c13",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 10",
														"attributes":{
															"id":"Cf88987f7-7406-4de3-85bf-8e0eb2fb0621",
														}
													}
												],
												"custom-name":"Button 10"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C7695bff2-850b-469f-8efa-55e416676584",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 11",
														"attributes":{
															"id":"Cb56cf33e-c160-4689-9106-04230c77b664",
														}
													}
												],
												"custom-name":"Button 11"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C3f0bfbff-1ed4-4d14-b835-3cbeea59b04c",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 12",
														"attributes":{
															"id":"Cce1a39e9-df54-4ba2-8336-3e5508b5301f",
														}
													}
												],
												"custom-name":"Button 12"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C6479da3f-cd86-4746-8863-5891e17e41d1",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 13",
														"attributes":{
															"id":"C35a4b64e-1d32-4338-b304-1cf302735980",
														}
													}
												],
												"custom-name":"Button 13"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"Ca65dea04-5f94-4e1f-9036-b1c0607acf60",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 14",
														"attributes":{
															"id":"Cafe3c6df-9de9-4f12-8521-1de86f9509bc",
														}
													}
												],
												"custom-name":"Button 14"
											},
											{
												"type":"div",
												"name":"Primary Button",
												"classes":[
													"primary-cta"
												],
												"attributes":{
													"id":"C75ada4ee-49b2-42d4-ab8e-78c610246fe6",
													"asset-id":""
												},
												"components":[
													{
														"type":"e-text",
														"name":"Label",
														"content":"Button 15",
														"attributes":{
															"id":"C780ac222-a83d-4048-8c24-aa16e9d38a90",
														}
													}
												],
												"custom-name":"Button 15"
											}
										],
										"custom-name":"Buttons"
									},
									{
										"type":"div",
										"name":"Home Button",
										"classes":[
											"secondary-icon-cta"
										],
										"attributes":{
											"id":"Ce817947a-fae3-4aab-be2a-410feadd3c2a",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Icon",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"Ca7d17367-12f2-42a2-9c14-eb2e5220f85d",
													"asset-id":"",
													"src":embeddedImagesBase64.home,
													"data-action":""
												}
											}
										]
									},
									{
										"type":"div",
										"attributes":{
											"id":"Cc5fc91b1-ad00-42dd-afeb-34e275a95747",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Next Button",
												"classes":[
													"primary-icon-cta"
												],
												"attributes":{
													"id":"Ccf56aadf-2a5e-4ea4-ae17-9272ff51fead",
													"data-action":"next_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Ce23ef9cd-6ddc-45ca-82de-d1f7d3917098",
															"asset-id":"",
															"src":embeddedImagesBase64.next,
														}
													}
												]
											},
											{
												"type":"div",
												"name":"Previous Button",
												"classes":[
													"secondary-icon-cta"
												],
												"attributes":{
													"id":"C936ed833-5055-427b-b5d0-1cbb8c31c3e4",
													"data-action":"previous_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cc7e5fad7-c046-4135-ae88-df9f9049cf31",
															"asset-id":"",
															"src":embeddedImagesBase64.prev,
														}
													}
												]
											}
										],
										"custom-name":"Prev/Next Buttons",
										"__prev-display":"flex"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Branch"
					},
					"id":"3nlezYZ5KJkojzCF"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateBranch;